var map = {
	"./Dysrhythmia_Question1.jpg": 396,
	"./Dysrhythmia_Question10.jpg": 397,
	"./Dysrhythmia_Question2.jpg": 398,
	"./Dysrhythmia_Question3.jpg": 399,
	"./Dysrhythmia_Question4.jpg": 400,
	"./Dysrhythmia_Question5.jpg": 401,
	"./Dysrhythmia_Question6.jpg": 402,
	"./Dysrhythmia_Question7.jpg": 403,
	"./Dysrhythmia_Question8.jpg": 404,
	"./Dysrhythmia_Question9.jpg": 405,
	"./color_blind_image_1.jpg": 406,
	"./color_blind_image_10.jpg": 407,
	"./color_blind_image_2.jpg": 408,
	"./color_blind_image_3.jpg": 409,
	"./color_blind_image_4.jpg": 410,
	"./color_blind_image_5.jpg": 411,
	"./color_blind_image_6.jpg": 412,
	"./color_blind_image_7.jpg": 413,
	"./color_blind_image_8.jpg": 414,
	"./color_blind_image_9.jpg": 415,
	"./image_company.jpg": 193
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 140;